import React, {Component} from 'react';
import {Mutation} from 'react-apollo';
import gql from 'graphql-tag';
import DateRangePickerContainer from './date-range-picker';
import GuestPickerContainer from './guest-picker';
import {withAuth} from '../../../components/auth';
import edap from '../../edap';

const updateStayOnTripBoard = gql`
mutation updateStayOnTripBoard($hav: String!, $tripBoardUuid: String!, $stay: StayInput!) {
    updateStayOnTripBoard(
        hav: $hav
        tripBoardUuid: $tripBoardUuid
        stay: $stay
    )
}`;

const resetTripBoardDates = gql`
mutation resetTripBoardDates($hav: String!, $tripBoardUuid: String!) {
    resetTripBoardDates(hav: $hav, tripBoardUuid: $tripBoardUuid)
}`;

class StayContextContainer extends Component {
    constructor(props) {
        super(props);
    }

    handleNewDates = (startDate, endDate) => {
        if (startDate && endDate) {
            this.handleUpdateStay(null, null, null, startDate, endDate)
        } else {
            const noDates = {
                variables: {
                    hav: this.props.hav,
                    tripBoardUuid: this.props.boardId
                }
            }
            this.props.deleteDates(noDates);
        }
        edap.datesChange(this.props.boardId, startDate, endDate);
    }

    handleNewGuests = (adultsCount, childrenCount, petsIncluded) => {
        edap.guestsChange(this.props.boardId, adultsCount, childrenCount, petsIncluded);
        this.handleUpdateStay(adultsCount, childrenCount, petsIncluded, null, null)
    }

    handleUpdateStay = (adultsCount = 2, childrenCount = 0, petsIncluded = false, startDate, endDate) => {
        const tripBoardUuid = this.props.boardId;
        const hav = this.props.hav;
        const updatedStay = {
            variables: {
                hav,
                tripBoardUuid,
                stay: {
                    adultCount: (adultsCount !== null) ? adultsCount : this.props.adultsCount,
                    childrenCount: (childrenCount !== null) ? childrenCount : this.props.childrenCount,
                    petsIncluded: (petsIncluded !== null) ? petsIncluded : this.props.petsIncluded,
                    ...(((startDate || this.props.startDate) && (endDate || this.props.endDate)) && 
                    {
                        dateRange: 
                        {
                            arrival: startDate || this.props.startDate,
                            departure: endDate || this.props.endDate
                        }
                    })
                }
            }
        }

        this.props.updateStay(updatedStay);
    }

    onGuestsClick = () => {
        edap.guestsClick(this.props.boardId);
    }

    onDatesClick = () => {
        edap.datesClick(this.props.boardId);
    }

    render() {
        const {
            boardId,
            endDate,
            locale,
            startDate,
            adultsCount = 2,
            childrenCount = 0,
            petsIncluded = false,
            isGuestContextTestOn
        } = this.props;

        return (
            <React.Fragment>
                <div className="col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xlg-2 trip-board-details__date-picker">
                    <DateRangePickerContainer
                        boardId={boardId}
                        endDate={endDate}
                        locale={locale}
                        onNewDates={this.handleNewDates}
                        onDatesClick={this.onDatesClick}
                        startDate={startDate}
                    />
                </div>
                <div className="col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xlg-2 trip-board-details__guest-picker">
                    {isGuestContextTestOn &&
                        <GuestPickerContainer
                            adultsCount={adultsCount}
                            boardId={boardId}
                            childrenCount={childrenCount}
                            endDate={endDate}
                            onGuestsClick={this.onGuestsClick}
                            onNewGuests={this.handleNewGuests}
                            petsIncluded={petsIncluded}
                            startDate={startDate}
                        />
                    }
                </div>
            </React.Fragment>
        );
    }
}

const handleMutationError = (onError = () => {}) => () => {
    onError();
};

const StayContextContainerProvider = ({
    hav,
    onError,
    adultsCount,
    boardId,
    childrenCount,
    endDate,
    locale,
    petsIncluded,
    startDate,
    isGuestContextTestOn,
    refetchTripboard
}) => {
    return (
        <Mutation 
            mutation={updateStayOnTripBoard}
            onError={handleMutationError(onError)}
            onCompleted={refetchTripboard}
        >
            {(updateStay) => (
                <Mutation
                    mutation={resetTripBoardDates}
                    onError={handleMutationError(onError)}
                    onCompleted={refetchTripboard}
                >
                    {(deleteDates) => {
                        return (
                            <StayContextContainer
                                updateStay={updateStay}
                                deleteDates={deleteDates}
                                hav={hav}
                                adultsCount={adultsCount}
                                boardId={boardId}
                                childrenCount={childrenCount}
                                endDate={endDate}
                                locale={locale}
                                petsIncluded={petsIncluded}
                                startDate={startDate}
                                isGuestContextTestOn={isGuestContextTestOn}
                            />
                        );
                    }}
                </Mutation>
            )}
        </Mutation>
    );
};

export default withAuth(StayContextContainerProvider);


// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/stay-context-container.js